import React,{ useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Col, Row, Nav, Container, Tab, Button, Form} from 'react-bootstrap';
import Dropdown from 'react-bootstrap/Dropdown';
import { Link } from 'react-router-dom';
import { auth } from "../config/Config";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { createMaterials } from '../redux/addMaterialReducer';
import Sidebar from './SidebarNav';

export default function Render() {
  const navigation = useNavigate();
  const dispatch = useDispatch();
  
  const handleLogOut =()=>{
    auth.signOut();
    // navigation('/login');
  }
// useEffect(()=>console.log('ffff', data), []);
  useEffect(()=>{
  auth.onAuthStateChanged(user => {
    const routeName = user !== null ? '/render' : '/login';
    navigation(routeName);
  });
}, []);

const { userData, userLoader, userError} = useSelector((state)=>state.viewusers);




const [roomTypeTableName, setRoomTypeTableName] = useState("");
const [roomTypeMaterialName, setRoomTypeMaterialName] = useState("");
const [roomTypeMeasurement, setRoomTypeMeasurement] = useState("");

//for dynamic fields
const [materialFields, setMaterialFields] = useState([{ label: '', value: '' }]); 


const handleAddField = () => {
  setMaterialFields([...materialFields, { label: '', value: '' }]); 
};

const handleRemoveField = (index) => {
  const updatedFields = [...materialFields];
  updatedFields.splice(index, 1);
  setMaterialFields(updatedFields);
};

const handleFieldChange = (value, index, fieldName) => {
  const updatedFields = [...materialFields];
  updatedFields[index][fieldName] = value;
  setMaterialFields(updatedFields);
};


const handleSubmit = () => {
  // e.preventDefault();
  // Handle form submission here, e.g., save data to the server or state
  console.log(materialFields);
  

  // Reset the form fields after submission
  // setMaterialFields([{ firstName: '', lastName: '' }]);
};





const handleAddingRoomMaterialCancel = () => {

}

const handleAddingRoomMaterial = () => {
const allData = {
  material:materialFields,
  name:roomTypeMaterialName,
  measurement:roomTypeMeasurement,
  table:roomTypeTableName,
  timestamp: new Date(),
};

dispatch(createMaterials(allData));
setRoomTypeTableName("");
setRoomTypeMaterialName("");
setRoomTypeMeasurement("");
setMaterialFields([{ label: '', value: '' }]);

}
  return (
    <Container fluid>
    <Row>
    <Col sm={1} style={{ backgroundColor: '#fdc771' }}>
          <Tab.Container  >
            <Row>
            </Row>
          </Tab.Container>
        </Col>
      <Col sm={11} className="m-0">
        <Row>
          <Col style={{
                backgroundColor: "#f5f8f8",
                display: "flex",
                flexDirection: "row",
                padding: "1%",
                justifyContent: "space-between",
              }}>
              <Col sm={10}>
              <p style={{ fontSize: 20, fontWeight: "bold" }}>Render</p>
              </Col>
            
              <Col sm={2}>
            
              </Col>
          </Col>
        </Row>
        <Row className="p-5">
       
        <Row className="p-2" style={{ backgroundColor: "#F2F2F2", height: 'auto' }}>
              
              <Row>

                <Col
                  sm={12}
                >
                  <Container>
                  <Form>
                 
                  <Row className='mb-2'>
                  <Col sm={7}> <h3>Add Materials for Rooms</h3></Col>
                            <Col><h5>Add Materials options</h5></Col>
                            <Col><Button  variant="success" onClick={handleAddField} > Add options <i class="bi bi-plus-circle-fill"></i> </Button></Col>
                          </Row>
                    <Row style={{ backgroundColor: "#F2F2F2", height: 'auto', overflowY: 'auto' }}>
                      <Col style={{ minHeight: 380, maxHeight: 480 }}>
                      
                       
                        <Row >
                          <Col sm={5}>
                          <Form.Group
                            className="mb-3"
                          
                          >
                            <Form.Label>Room Type</Form.Label>
                            <Form.Select value={roomTypeTableName} onChange={(e) => { setRoomTypeTableName(e.currentTarget.value) }} aria-label="Default select example" required >
                              <option>Select a Room</option>
                              <option value="kitchen">Kitchen</option>
                              <option value="Bedroom">Bedroom</option>
                              <option value="Foyer">Foyer</option>
                              <option value="LivingRoom">Living Room</option>
                              <option value="OtherWorks">Other Works</option>
                              <option value="LooseFurniture">Loose Furniture</option>
                              <option value="Accessories">Accessories</option>
                            </Form.Select>

                          </Form.Group>

                          <Form.Group
                            className="mb-3"
                         
                          >
                            <Form.Label>Material Name</Form.Label>
                            <Form.Control
                              type="text"
                              value={roomTypeMaterialName}
                              onChange={(e) => { setRoomTypeMaterialName(e.target.value) }}
                              placeholder="Laminate / PU "
                              required
                         
                            />
                          </Form.Group>
                          <Form.Group
                            className="mb-3"
                            
                          >
                            <Form.Label>Measurement</Form.Label>
                             <Form.Select value={roomTypeMeasurement} onChange={(e) => { setRoomTypeMeasurement(e.currentTarget.value) }} aria-label="Default select example" required >
                              <option>Select Measurement Type</option>
                              <option value="area">Area</option>
                              <option value="width">Width &  Height</option>
                              <option value="rft">RFT</option>
                              <option value="qty">Quantity</option>
                              <option value="length">Width & Length</option>
                              <option value="depth">Length, Height & Depth</option>
                              <option value="selection">Selection</option>
                            </Form.Select>
                          </Form.Group>
                          </Col>
                          <Col sm={7}>
                          
                          
                          {materialFields.map((field, index) => (
                            <Row key={index}>
                            <Col> <Form.Group
                            className="mb-3"
                           
                          >
                           
                            <Form.Control
                              type="text"
                              value={field.label}
                              onChange={(e) => handleFieldChange(e.target.value, index, 'label')}
                              placeholder="Label"
                              required={false}
                            />
                          </Form.Group></Col>
                            <Col> <Form.Group
                            className="mb-3"
                            
                          >
                           
                            <Form.Control
                              type="number"
                              value={field.value}
                              onChange={(e) => handleFieldChange(e.target.value, index, 'value')}
                              placeholder="Value"
                              required={false}
                            />
                          </Form.Group>
                          </Col>
                            <Col> <Button variant="danger" onClick={() => handleRemoveField(index)} >
                            <i class="bi bi-x-circle-fill"></i>
                            </Button></Col>
                            <Col>
                          
                          </Col>
                          </Row>
                           ))}
                          
                          </Col>
                          
                        </Row>
                          
                         
                        
                       
                      </Col>
                    </Row>
                    <Form.Group>
                            <Button variant="secondary" onClick={() => handleAddingRoomMaterialCancel()} className="w-25 mx-4">
                              Cancel
                            </Button>
                            <Button variant="success" onClick={() => handleAddingRoomMaterial()} className="w-25 mx-4">
                              Save
                            </Button>
                            
                          </Form.Group>
                        </Form>

                  </Container>

                </Col>
              </Row>
            
            
          </Row>
         
        </Row>
      </Col>
    </Row>
  </Container>
  );
}


